import { NgIf } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'd-footer',
  standalone: true,
  imports: [NgIf],
  templateUrl: './d-footer.component.html',
  styleUrl: './d-footer.component.scss',
})
export class DFooterComponent {

  disclaimer = true;

  closeDisclaimer() {
    this.disclaimer = !this.disclaimer;
  }  
}
